import script from "./CertificateRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateRequest.vue?vue&type=script&setup=true&lang=js"

import "./CertificateRequest.vue?vue&type=style&index=0&id=75fa7d32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75fa7d32"]])

export default __exports__